export const ReverificationSubmitFormFields = {
  paymentMethodId: 'paymentMethodId',
} as const;
export type ReverificationSubmitFormFields =
  (typeof ReverificationSubmitFormFields)[keyof typeof ReverificationSubmitFormFields];

export type ReverificationSubmitFormValues = {
  [ReverificationSubmitFormFields.paymentMethodId]?: string | null;
};
